var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading},on:{"click":_vm.callAutoCapture}},[_vm._v("Call Auto Capture")])
}
var staticRenderFns = []

export { render, staticRenderFns }